import React, { useMemo, useState } from 'react'
import classes from './BeneficiaryContainer.module.css'
import { ReactComponent as Logo } from '../../assets/images/new-logo.png'
import { ReactComponent as Down } from '../../assets/icons/down.svg'
import { ReactComponent as SettingsIcon } from '../../assets/icons/settings.svg'
import { ReactComponent as CoursesIcon } from '../../assets/icons/beneficiary-icon-1.svg'
import { ReactComponent as LogOut } from '../../assets/icons/log-out.svg'
import { ReactComponent as BrowseCoursesIcon } from '../../assets/icons/beneficiary-icon-2.svg'
import { ReactComponent as ClassesIcon } from '../../assets/icons/beneficiary-icon-3.svg'
import { ReactComponent as Right } from '../../assets/icons/right.svg'
import { NavLink, useHistory } from 'react-router-dom'
import { createPortal } from 'react-dom'
import classNames from 'classnames'
import Swipe from '../../components/Swipe/Swipe'
import { AuthenticatedHeader } from '../../components/Header/AuthenticatedHeader'
import { userActions, userSelectors } from '../../redux/userSlice'
import { useSelector } from 'react-redux'

const sidenavLinks = [
    {
        to: '/app/beneficiary/my-courses',
        text: 'My Courses',
        id: 'my-courses',
        icon: CoursesIcon,
    },
    {
        to: '/app/beneficiary/settings',
        text: 'Settings',
        id: 'settings',
        icon: SettingsIcon,
    },
]

const acquireSidenavRoot = () => {
    let root = document.getElementById('sidenav-root')
    if (!root) {
        root = document.createElement('div')
        root.id = 'sidenav-root'
        document.body.appendChild(root)
    }
    return root
}

const BeneficiaryContainer = ({ children }) => {
    const [showing, setShowing] = useState(false)

    return (
        <Swipe
            onSwipeLeft={() => setShowing(false)}
            onSwipeRight={() => setShowing(true)}
        >
            <AuthenticatedHeader className={classes.header} />
            <div className={classes.container}>
                <aside className={classes.sidenav}>
                    {sidenavLinks.map(({ text, to, icon: Icon }, idx) => (
                        <NavLink
                            to={to}
                            className={classes.sidenavLink}
                            activeClassName={classes.sidenavLinkActive}
                            key={idx}
                        >
                            <Icon className={classes.sidenavLinkIcon} />
                            {text}
                        </NavLink>
                    ))}
                </aside>
                <div className={classes.pageContent}>{children}</div>
            </div>
            <MobileSideBar showing={showing} setShowing={setShowing} />
        </Swipe>
    )
}

const MobileSideBar = ({ showing, setShowing }) => {
    const root = useMemo(acquireSidenavRoot, [])

    const history = useHistory()

    const { domainName: businessDomainName } = useSelector(
        userSelectors.userDetails
    )

    const logOut = () => {
        userActions.logout()
        history.push(`/app/beneficiary/${businessDomainName}/sign-in`)
    }

    const content = (
        <>
            <Swipe
                onSwipeLeft={() => setShowing(false)}
                onSwipeRight={() => setShowing(true)}
            >
                {/*Transition delay when showing goes from 300 to 600. When hidden goes from 300 to 0*/}
                <div
                    className={classNames(
                        classes.sideBarMain,
                        showing && classes.sideBarMainActive
                    )}
                >
                    {sidenavLinks.map(({ to, text, icon: Icon }, idx) => (
                        <NavLink
                            to={to}
                            className={classes.sideBarMainLink}
                            activeClassName={classes.sideBarMainLinkActive}
                            style={{
                                transitionDelay: `${
                                    showing
                                        ? 300 + 100 * idx
                                        : 100 * (sidenavLinks.length - idx)
                                }ms`,
                            }}
                        >
                            <Icon className={classes.sideBarMainIcon} />
                            {text}
                        </NavLink>
                    ))}
                    <button
                        className={classes.sideBarMainLink}
                        onClick={logOut}
                    >
                        <LogOut className={classes.sideBarMainIcon} />
                        Log Out
                    </button>
                </div>
            </Swipe>
            <button
                className={classes.sideBarButton}
                onClick={() => setShowing(!showing)}
            >
                <Right
                    className={classNames(classes.sideBarButtonIcon)}
                    style={{
                        transform: `rotate(${showing ? 270 : 90}deg)`,
                    }}
                />
            </button>
        </>
    )
    return createPortal(content, root)
}

export default BeneficiaryContainer
